import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaGithub, FaWhatsapp, FaMapMarkerAlt, FaPhone, FaStar, FaUsersCog, FaClipboardList, FaDollarSign, FaEnvelope, FaFileDownload } from 'react-icons/fa';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import TeamPage from './TeamPage';
import TechStack from '../components/landing/TechStack';
import { sendEvent } from '../utils/gtag';

const stats = [
  { value: '150+', label: 'Satisfied Clients Across the Globe' },
  { value: '250+', label: 'Projects delivered successfully' },
  { value: '75+', label: 'Experts under the same roof' },
];

const socialLinks = [
  { icon: <FaFacebook />, href: 'https://www.facebook.com/TechVelly2k25', name: 'facebook' },
  { icon: <FaTwitter />, href: 'https://x.com/Techvelly2025', name: 'twitter' },
  { icon: <FaLinkedin />, href: 'https://www.linkedin.com/company/techvelly', name: 'linkedin' },
  { icon: <FaGithub />, href: 'https://github.com/mhfaisalbd', name: 'github' },
];

const CompanyPage = () => {
  return (
    <div className="bg-white text-gray-800">
      <Header />
      {/* Section 1: Hero */}
      <section className="text-center py-20">
        <h1 className="text-4xl font-bold mb-4">We love building exceptional products.</h1>
        <p className="max-w-3xl mx-auto text-gray-600 mb-8">
          Well, that’s what drives us to our desks every day — building products that delight users, that solve business challenges, that make the world a better place, and that deliver promises. And, yes, we can do it for you too.
        </p>
    
          <h1 className="text-4xl font-bold mb-2">Innovate. Create. Elevate.</h1>
          <h2 className="text-2xl mb-4">Building the future together</h2>
        <img src="/team_image/Company.png" alt="Workplace" className="w-full h-auto rounded-sm" />

      </section>

      {/* Section 2: Stats */}
      <section className="bg-white py-20 text-center">
        <h2 className="text-3xl font-bold max-w-2xl mx-auto mb-12">We've helped businesses increase their revenue on average by 90% in their first year with us!</h2>
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm">
            <p className="text-5xl font-bold text-brand-dark">{stats[0].value}</p>
            <p className="text-xl font-semibold mt-2 text-gray-600">{stats[0].label}</p>
          </div>
          <div className="bg-gradient-to-r from-green-400 to-blue-500 p-8 rounded-lg shadow-lg text-white">
            <p className="text-5xl font-bold">{stats[1].value}</p>
            <p className="text-xl font-semibold mt-2">{stats[1].label}</p>
          </div>
          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm">
            <p className="text-5xl font-bold text-brand-dark">{stats[2].value}</p>
            <p className="text-xl font-semibold mt-2 text-gray-600">{stats[2].label}</p>
          </div>
        </div>
        <a href={`${process.env.REACT_APP_BACKEND_URL}/download/profile`} onClick={() => sendEvent('download_profile_click', { source: 'company_page_stats' })} download rel="noopener noreferrer">
        <button className="
          bg-gradient-to-r from-blue-500 to-green-400 
          text-white font-bold 
          py-3 px-8 
          rounded-lg shadow-md 
          transition-all duration-300 ease-in-out 
          hover:from-blue-600 hover:to-green-500 
          hover:scale-105 hover:shadow-lg 
          mt-12
        ">
          <FaFileDownload className="inline-block mr-2" />
          Download Company Profile
        </button>
        </a>
      </section>
      {/* Section 3: Values */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">
            What can you <span className="text-green-500 italic">expect from us.</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="flex flex-col gap-4">
              <div className="bg-white p-6 rounded-lg shadow-md flex items-center border border-gray-200">
                <FaStar className="text-green-500 text-2xl mr-4" />
                <h3 className="text-xl font-semibold text-gray-800">Passion for Action</h3>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md flex items-center border border-gray-200">
                <FaStar className="text-gray-400 text-2xl mr-4" />
                <h3 className="text-xl font-semibold text-gray-800">Strive for Excellence</h3>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md flex items-center border border-gray-200">
                <FaStar className="text-blue-500 text-2xl mr-4" />
                <h3 className="text-xl font-semibold text-gray-800">Creator-friendly, Customer-centric</h3>
              </div>
            </div>
            <div className="flex flex-col gap-8">
              <div>
                <div className="flex items-center mb-2">
                  <FaUsersCog className="text-purple-500 text-2xl mr-2" />
                  <span className="bg-purple-100 text-purple-800 text-sm font-semibold px-3 py-1 rounded-full">
                    Highly skilled people
                  </span>
                </div>
                <p className="text-gray-600">
                  Techvelly is known for its exceptionally skilled team, who are best in class in their fields and technologies. We are extremely diligent in selecting our team members and only hire people who comply with our high-quality standards and company culture. We are also focused on investing in our people and keeping them up to date with the latest skills and trends.
                </p>
              </div>
              <div>
                <div className="flex items-center mb-2">
                  <FaClipboardList className="text-orange-500 text-2xl mr-2" />
                  <span className="bg-orange-100 text-orange-800 text-sm font-semibold px-3 py-1 rounded-full">
                    Tested and efficient process
                  </span>
                </div>
                <p className="text-gray-600">
                  With hundreds of projects delivered in the last decade, we have tested and optimized our process for maximum efficiency. Working with us will ensure you get speedy delivery, adaptability, predictability, and tangible results.
                </p>
              </div>
              <div>
                <div className="flex items-center mb-2">
                  <FaDollarSign className="text-blue-500 text-2xl mr-2" />
                  <span className="bg-blue-100 text-blue-800 text-sm font-semibold px-3 py-1 rounded-full">
                    Unmatched ROI
                  </span>
                </div>
                <p className="text-gray-600">
                  We know product development is a huge investment. But when you do it right, with the right development partner, the returns you reap are even more massive. At Techuz, we’re committed to making it possible. We provide unparalleled quality, expertise, and experience to each of our clients for maximum return on investment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TechStack />

      {/* Section 4: Team */}
      <section className="bg-gray-50 py-20">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Meet our team.</h2>
          <p className="max-w-3xl mx-auto text-gray-600 mb-8">
            We're a team of experts from various disciplines—technology, design, business, media—passionate about creating and delivering excellent products.
          </p>
          <TeamPage/>
        </div>
      </section>

      {/* Section 5: Our Locations */} 
      <section className="bg-[#35a89d]/5" id="contact">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-12">Our Locations</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="text-left p-8 bg-white rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
              <h3 className="text-2xl font-bold mb-4 flex items-center"><FaMapMarkerAlt className="mr-3 text-blue-500"/>Malaysia</h3>
              <p className="font-semibold">TECHVELLY SDN.BHD</p>
              <p className="mb-4">Level 09, Integra Tower, The Intermark 348, Jalan Tun Razak, Kampung Datuk Keramat 50400 Kuala Lumpur W.P Kuala Lumpur Malaysia</p>
              <p className="flex items-center"><FaPhone className="mr-3 text-green-500"/><a href='tel:+6001116171438' onClick={() => sendEvent('contact_info_click', { type: 'phone', location: 'malaysia' })}>+6001116171438</a></p>
              <p className="flex items-center"><FaEnvelope className="mr-3 text-blue-500" /> <a href="mailto:kualalumpur@techvelly.com" onClick={() => sendEvent('contact_info_click', { type: 'email', location: 'malaysia' })} className="hover:text-blue-500">kualalumpur@techvelly.com</a></p>
              
              <a href="https://wa.me/+6001116171438" onClick={() => sendEvent('contact_info_click', { type: 'whatsapp', location: 'malaysia' })} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-500 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-green-600 transition-colors duration-300 mt-4 mb-8">
              <FaWhatsapp className="inline-block mr-2" /> Call on WhatsApp
            </a>
            </div>
            <div className="text-left p-8 bg-white rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
              <h3 className="text-2xl font-bold mb-4 flex items-center"><FaMapMarkerAlt className="mr-3 text-blue-500"/>Dhaka</h3>
              <p className="font-semibold">TECHVELLY SDN.BHD DHAKA OFFICE</p>
              <p className="mb-4">60 Feet, North Pirerbugh, Mirpur <br/>Dhaka-1216, Bangladesh</p>
              <p className="flex items-center"><FaPhone className="mr-3 text-green-500"/> <a href='tel:+8801927046394' onClick={() => sendEvent('contact_info_click', { type: 'phone', location: 'dhaka' })}>+8801927046394</a></p>
              <p className="flex items-center"><FaEnvelope className="mr-3 text-blue-500" /> <a href="mailto:dhaka@techvelly.com" onClick={() => sendEvent('contact_info_click', { type: 'email', location: 'dhaka' })} className="hover:text-blue-500">dhaka@techvelly.com</a></p>
              
              <a href="https://wa.me/8801927046394" onClick={() => sendEvent('contact_info_click', { type: 'whatsapp', location: 'dhaka' })} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-500 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-green-600 transition-colors duration-300 mt-4 mb-8">
              <FaWhatsapp className="inline-block mr-2" /> Call on WhatsApp
            </a>
            </div>
            <div className="text-left p-8 bg-white rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
              <h3 className="text-2xl font-bold mb-4 flex items-center"><FaMapMarkerAlt className="mr-3 text-blue-500"/>Ontario, Canada</h3>
              <p className="font-semibold">TECHVELLY SDN.BHD ONTARIO OFFICE</p>
              <p className="mb-4">1844 Wavell St, London, N5W2E4, Ontario, Canada</p>
              <p className="flex items-center"><FaPhone className="mr-3 text-green-500"/> <a href='tel:+14372263887' onClick={() => sendEvent('contact_info_click', { type: 'phone', location: 'dhaka' })}>+14372263887</a></p>
              <p className="flex items-center"><FaEnvelope className="mr-3 text-blue-500" /> <a href="mailto:ontario@techvelly.com" onClick={() => sendEvent('contact_info_click', { type: 'email', location: 'ontario' })} className="hover:text-blue-500">ontario@techvelly.com</a></p>
              
              <a href="https://wa.me/8801927046394" onClick={() => sendEvent('contact_info_click', { type: 'whatsapp', location: 'dhaka' })} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-500 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-green-600 transition-colors duration-300 mt-4 mb-8">
              <FaWhatsapp className="inline-block mr-2" /> Call on WhatsApp
            </a>
            </div>
          </div>
        </div>
      </section>
      
      {/* Section 6: Contact/CTA */}
      <section className="bg-gray-100 py-20">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div class='text-left p-8'>
            <h3 class="text-2xl font-bold mb-4">Inquiries:</h3>
            <p class="mb-2 flex items-center"> <FaEnvelope class="mr-3 text-green-500"/> <a href="mailto:info@techvelly.com" onClick={() => sendEvent('contact_info_click', { type: 'email', location: 'general_inquiries' })} className="hover:text-blue-500">info@techvelly.com</a></p>
            <p class="mb-2 flex items-center"> <FaEnvelope class="mr-3 text-green-500"/> <a href="mailto:sales@techvelly.com" onClick={() => sendEvent('contact_info_click', { type: 'email', location: 'general_sales' })} className="hover:text-blue-500">sales@techvelly.com</a></p>
            
            
          

           <p class="mb-8 flex items-center"><FaPhone class="mr-3 text-green-500"/> <a href='tel:+8809611609244' onClick={() => sendEvent('contact_info_click', { type: 'phone', location: 'general' })}>+8809611609244</a> </p>
            <div className="flex space-x-4">
              {socialLinks.map((link, index) => (
                <a key={index} href={link.href} onClick={() => sendEvent('contact_info_click', { type: 'social', name: link.name })} className="text-gray-600 hover:text-blue-500 text-2xl">{link.icon}</a>
              ))}
            </div>
          </div>
          <div className="bg-gradient-to-tr from-[#264864] via-[#264864] to-[#35a89d] p-8 pt-16 pb-16 rounded-lg shadow-lg text-center">
            <h3 className="text-2xl text-white font-bold mb-4">Get the real estimates and ideal solutions for your project.</h3>
            <div className="flex justify-center space-x-4 mt-6">
                <Link to="/#quote-form" className="bg-blue-500 text-white font-bold py-3 px-8 rounded-lg shadow-md hover:bg-blue-600 transition-colors duration-300">
                  Get an estimate
                </Link>
                <a href={`${process.env.REACT_APP_BACKEND_URL}/download/profile`} onClick={() => sendEvent('download_profile_click', { source: 'company_page_cta' })} download rel="noopener noreferrer">
                <button className="bg-white text-blue-500 font-bold py-3 px-8 rounded-lg shadow-md hover:bg-gray-200 transition-colors duration-300">
                    
                    Download Profile
                </button>
                </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompanyPage;